export default {
  path: '/wecode/search',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'new-indexsearch',
  component: () => import( /* webpackChunkName: "home" */'./index')
};
